import { ThemeConfig } from '@chakra-ui/react';

export const cardsGridGap = 30;
const breakpoints = {
    base: '0em',
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
};

const styles = {
    global: () => ({
        body: {
            fontFamily: 'body',
            lineHeight: 'base',
        },
    }),
};

const baseThemeConfig: ThemeConfig = {
    initialColorMode: 'system',
    useSystemColorMode: true,
};

export { breakpoints, baseThemeConfig, styles };
